import React from 'react';

const ContactInfo = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
      <div className="bg-gray-800 rounded-xl p-6 shadow-lg hover:shadow-purple-500/10 transition-all">
        <div className="flex items-center mb-4 text-purple-400">
          <svg className="w-8 h-8 mr-3" fill="currentColor" viewBox="0 0 24 24">
            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
          </svg>
          <h3 className="text-xl font-semibold text-white">Telefonos elérhetőség</h3>
        </div>
        <div className="space-y-3 text-gray-300">
          <p className="flex items-center">
            <span className="font-medium mr-2">Központi szám:</span>
            <a href="tel:+36709083086" className="text-purple-400 hover:text-purple-300">
              +36 70 908 3086
            </a>
          </p>
          <p className="text-sm text-purple-400 mt-4">
            Hívjon bizalommal szakértő kollégáinkat!
          </p>
        </div>
      </div>

      <div className="bg-gray-800 rounded-xl p-6 shadow-lg hover:shadow-purple-500/10 transition-all">
        <div className="flex items-center mb-4 text-purple-400">
          <svg className="w-8 h-8 mr-3" fill="currentColor" viewBox="0 0 24 24">
            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
          </svg>
          <h3 className="text-xl font-semibold text-white">Email elérhetőség</h3>
        </div>
        <div className="space-y-3 text-gray-300">
          <p className="flex items-center">
            <span className="font-medium mr-2">Email címünk:</span>
            <a href="mailto:support@webforyou.hu" className="text-purple-400 hover:text-purple-300">
              support@webforyou.hu
            </a>
          </p>
          <p className="text-sm text-purple-400 mt-4">
            Írjon nekünk, 24 órán belül válaszolunk!
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo; 